import React from 'react';
import { Box, Typography } from '@mui/material';

export default function PoweredByIdotoo({ sx = {} }) {
  return (
    <Box
      component="a"
      href="https://idotoo.ai"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Idotoo — opens idotoo.ai in a new tab"
      sx={{
        display: 'block',
        mt: 2,
        textAlign: 'center',
        textDecoration: 'none',
        color: 'text.secondary',
        opacity: 0.85,
        transition: 'opacity 0.15s ease',
        '&:hover': {
          opacity: 1
        },
        ...sx
      }}
    >
      <Typography
        component="div"
        variant="caption"
        sx={{ fontSize: '0.75rem', lineHeight: 1.4 }}
      >
        Powered by Idotoo
      </Typography>
      <Box
        component="img"
        src="/img/logo.svg"
        alt=""
        aria-hidden
        sx={{
          height: 20,
          mt: 0.75,
          opacity: 0.9,
          display: 'inline-block'
        }}
        onError={(event) => {
          event.currentTarget.style.display = 'none';
        }}
      />
    </Box>
  );
}
